import AcquireTokenCallback from './schema/AcquireTokenCallback';

export { default as registerTokenProvider } from './registerTokenProvider';
export { getAccessTokenforResource } from './getAccessTokenforResource';
export { getAccessTokenforResourceAsLazy } from './getAccessTokenforResource';
export { getDelegationToken, getDelegationTokenForOwa } from './getDelegationToken';
export { bootstrap } from './bootstrap';
export { getAccessTokenOnBehalfOfResource } from './getAccessTokenOnBehalfOfResource';

export { AcquireTokenCallback };
